export enum MemberStatusEnum {
  Payer = 1,
  Recipient = 2,
  PayerRepresentative = 3,
  RecipientRepresentative = 4,
  PayerBeneficiary = 6,
  RecipientBeneficiary  = 8,
}
